import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';
import * as typography from '@tapas/typography';

var StyledTextareaOuterWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var StyledTextareaInnerWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledLabel = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  box-sizing: border-box;\n  position: absolute;\n  top: 1.6rem;\n  left: 1.6rem;\n  width: 100%;\n  z-index: ", ";\n  height: ", ";\n  color: ", ";\n"], ["\n  ", "\n  box-sizing: border-box;\n  position: absolute;\n  top: 1.6rem;\n  left: 1.6rem;\n  width: 100%;\n  z-index: ", ";\n  height: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, isFocused = _a.isFocused, textareaValue = _a.textareaValue;
    return isFocused || textareaValue
        ? typography.caption(theme.fonts.default, 300)
        : typography.body(theme.fonts.default, 1.6, 300);
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
}, function (_a) {
    var isFocused = _a.isFocused, textareaValue = _a.textareaValue;
    return isFocused || textareaValue ? '1.8rem' : '2.1rem';
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled, validState = _a.validState;
    if (disabled) {
        return theme.colorTokens.text.disabled;
    }
    if (validState === 'error') {
        return theme.colorTokens.system.danger.default;
    }
    return theme.colorTokens.text.placeholder;
});
var StyledTextarea = styled.textarea(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  ", "\n  box-sizing: border-box;\n  background-color: ", ";\n  width: 100%;\n  height: ", ";\n  border: 0.1rem solid\n    ", ";\n  border-radius: 0.8rem;\n  outline: none;\n  padding: 3.4rem 1.6rem 1.6rem;\n  color: ", ";\n  resize: ", ";\n\n  /* TODO \uB9AC\uC0AC\uC774\uC988 \uBC84\uD2BC \uB9CC\uB4E4\uAE30(\uD30C\uC774\uC5B4\uD3ED\uC2A4\uB294 \uB9AC\uC0AC\uC774\uC988 \uBC84\uD2BC\uC744 \uB9CC\uB4E4 \uC218 \uC5C6\uC74C)  */\n  /* ::-webkit-resizer {\n    position: absolute;\n  } */\n"], ["\n  position: relative;\n  ", "\n  box-sizing: border-box;\n  background-color: ", ";\n  width: 100%;\n  height: ", ";\n  border: 0.1rem solid\n    ", ";\n  border-radius: 0.8rem;\n  outline: none;\n  padding: 3.4rem 1.6rem 1.6rem;\n  color: ", ";\n  resize: ", ";\n\n  /* TODO \uB9AC\uC0AC\uC774\uC988 \uBC84\uD2BC \uB9CC\uB4E4\uAE30(\uD30C\uC774\uC5B4\uD3ED\uC2A4\uB294 \uB9AC\uC0AC\uC774\uC988 \uBC84\uD2BC\uC744 \uB9CC\uB4E4 \uC218 \uC5C6\uC74C)  */\n  /* ::-webkit-resizer {\n    position: absolute;\n  } */\n"])), function (_a) {
    var theme = _a.theme;
    return typography.body(theme.fonts.default, 1.4, 300);
}, function (_a) {
    var theme = _a.theme, readOnly = _a.readOnly, disabled = _a.disabled;
    if (readOnly || disabled) {
        return theme.colorTokens.hierarchy.h5;
    }
    return theme.colorTokens.background.base;
}, function (_a) {
    var height = _a.height;
    return typeof height === 'string' && height ? height : 'auto';
}, function (_a) {
    var theme = _a.theme, validState = _a.validState;
    return validState !== 'error'
        ? theme.colorTokens.hierarchy.h4
        : theme.colorTokens.system.danger.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.text.primary;
}, function (_a) {
    var resize = _a.resize;
    return resize;
});
var StyledDescriptionWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n  margin-top: 0.2rem;\n  background-color: ", ";\n"], ["\n  width: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n  margin-top: 0.2rem;\n  background-color: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var reverseDirection = _a.reverseDirection;
    return reverseDirection ? 'row-reverse' : 'row';
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.background.base;
});
var LengthLimitCaption = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n"], ["\n  ", "\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return typography.caption(theme.fonts.default, 300);
}, function (_a) {
    var theme = _a.theme, state = _a.state;
    return state === 'error'
        ? theme.colorTokens.system.danger.default
        : theme.colorTokens.text.secondary;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { LengthLimitCaption, StyledDescriptionWrapper, StyledLabel, StyledTextarea, StyledTextareaInnerWrapper, StyledTextareaOuterWrapper };
